export const CTV_OPTIONS = [
  {
    label:
      '<img class="mr-2" src="/assets/images/roku.png" alt="Roku Icon"/> Roku',
    value: 'roku'
  },
  {
    label:
      '<img class="mr-2" src="/assets/images/firetv.png" alt="Fire TV Icon"/> Fire TV',
    value: 'firetv'
  },
  {
    label:
      '<img class="mr-1" src="/assets/images/samsung.png" alt="Samsung Icon"/> Samsung',
    value: 'samsung'
  },
  {
    label:
      '<img class="mr-1" src="/assets/images/tvos.png" alt="tvOS Icon"/> tvOS',
    value: 'tvos'
  }
  // {
  //   label:
  //     '<img class="mr-1" src="/assets/images/lgtv.png" alt="LG TV Icon"/> LG TV',
  //   value: 'LG TV'
  // }
];

// `value` is the device slug used in routes and filters, shared with every
// other CTV report; `apiValue` is the platform name the Seller Trust Index API
// expects. See constants/PLATFORM_SLUGS.ts. MR-2633
export const CTV_STI_OPTIONS = [
  {
    label:
      '<img class="mr-2" src="/assets/images/roku.png" alt="Roku Icon"/> Roku',
    value: 'roku',
    apiValue: 'Roku'
  },
  {
    label:
      '<img class="mr-2" src="/assets/images/firetv.png" alt="Fire TV Icon"/> Fire TV',
    value: 'firetv',
    apiValue: 'Amazon'
  },
  {
    label:
      '<img class="mr-1" src="/assets/images/samsung.png" alt="Samsung Icon"/> Samsung',
    value: 'samsung',
    apiValue: 'Samsung'
  },
  {
    label:
      '<img class="mr-1" src="/assets/images/tvos.png" alt="tvOS Icon"/> tvOS',
    value: 'tvos',
    apiValue: 'tvOS'
  },
  {
    label:
      '<img class="mr-1" src="/assets/images/lgtv.png" alt="LG TV Icon"/> LG TV',
    value: 'lgtv',
    apiValue: 'LG'
  }
];

export const REGION_COUNTRY_MAPPING = [
  {
    region: 'APAC',
    countries:
      'AS,AU,BD,BN,BT,CC,CN,CX,FJ,FM,GU,HK,ID,IN,IO,JP,KH,KI,KP,KR,LA,LK,MH,MM,MN,MO,MP,MV,MY,NF,NP,NR,NU,NZ,PG,PH,PK,PN,PW,SB,SG,TH,TK,TL,TO,TV,TW,UM,VN,VU,WS'
  },
  {
    region: 'EMEA',
    countries:
      'AD,AE,AF,AL,AM,AO,AQ,AT,AX,AZ,BA,BE,BF,BG,BH,BI,BJ,BL,BV,BW,BY,CD,CF,CG,CH,CI,CK,CM,CV,CW,CY,CZ,DE,DJ,DK,DZ,EE,EG,EH,ER,ES,ET,FI,FO,FR,GA,GB,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GW,HM,HR,HU,IE,IL,IM,IQ,IR,IS,IT,JE,JO,KE,KG,KM,KW,KZ,LB,LI,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MK,ML,MQ,MR,MT,MU,MW,MZ,NA,NAM,NC,NE,NG,NL,NO,OM,PF,PL,PM,PS,PT,QA,RE,RO,RS,RU,RW,SA,SC,SD,SE,SH,SI,SJ,SK,SL,SM,SN,SO,SS,ST,SX,SY,SZ,TD,TF,TG,TJ,TM,TN,TR,TZ,UA,UG,UZ,VA,WF,XK,YE,YT,ZA,ZM,ZW'
  },
  {
    region: 'LATAM',
    countries:
      'AG,AI,AR,AW,BB,BM,BO,BQ,BR,BS,BZ,CL,CO,CR,CU,DM,DO,EC,FK,GD,GS,GT,GY,HN,HT,JM,KN,KY,LC,MS,MX,NI,PA,PE,PR,PY,SR,SV,TC,TT,UY,VC,VE,VG,VI'
  },
  {
    region: 'NA',
    countries: 'CA,US'
  },
  {
    region: 'US'
  },
  {
    region: 'NON-US'
  }
];

export const DEFAULT_COUNTRY_PER_REGION_MAPPING = {
  NA: 'US',
  APAC: 'CN',
  EMEA: 'DE',
  LATAM: 'BR'
};
